<div class="prize-score">
    <h3 i18n>Points explained:</h3>
    <!-- <p class="list-title" i18n>Points</p> -->
    <ul class="list-head">
    </ul>
    <ul class="list">
        <li fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
            <span i18n>
                Achievement
            </span>
            <span i18n>
                Points
            </span>
        </li>
        <li *ngFor="let item of points" fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
            <span>
                {{item.name}}
            </span>
            <span class="points-bold-cls">
                {{!!item.points ? item.points: betMultiplier}}
            </span>
        </li>
    </ul>
</div>